import { BackButton, Breadcrumb } from 'components/app-header';
import Layout from 'components/layout';
import { LoadableContent } from 'components/loadable-content';

const DatasetCreate = () => (
  <>
    <BackButton />
    <Breadcrumb to='/' root>
      Datasets
    </Breadcrumb>
    <Breadcrumb to='/'>New dataset</Breadcrumb>
    <LoadableContent loading>
      <Layout direction='row' />
    </LoadableContent>
  </>
);

export { DatasetCreate };
